function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookMark1 = function SvgFacebookMark1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88 87.375"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M496.478 959.562a43.7 43.7 0 1 1 44-43.7 43.85 43.85 0 0 1-44 43.7m0-84.962a41.268 41.268 0 1 0 41.556 41.267 41.41 41.41 0 0 0-41.556-41.267m2.053 30.858v4.773h7.452l-.971 7.478h-6.481V936.9h-7.769v-19.191h-6.5v-7.478h6.5v-5.513c0-6.4 3.932-9.885 9.677-9.885a54 54 0 0 1 5.807.3v6.688h-3.984c-3.125-.003-3.731 1.471-3.731 3.637",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    transform: "translate(-452.469 -872.188)"
  }));
};
export default SvgFacebookMark1;